import React from 'react';

type Props = {
  direction: 'asc' | 'desc' | null;
  onAscClick: () => void;
  onDescClick: () => void;
};

/** Dual-chevron sort control (unsorted/asc/desc) for activity table headers. */
export function ActivityTableSortChevron({ direction, onAscClick, onDescClick }: Props) {
  const upActive = direction === 'asc';
  const downActive = direction === 'desc';

  return (
    <span className="activity-sort-glyphs" aria-hidden>
      <button
        type="button"
        className={`activity-sort-arrow ${upActive ? 'active' : ''}`}
        aria-label="Sort ascending"
        onClick={e => {
          e.stopPropagation();
          onAscClick();
        }}
      >
        <svg width="18" height="13" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6 15l6-6 6 6"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      <button
        type="button"
        className={`activity-sort-arrow ${downActive ? 'active' : ''}`}
        aria-label="Sort descending"
        onClick={e => {
          e.stopPropagation();
          onDescClick();
        }}
      >
        <svg width="14" height="10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6 9l6 6 6-6"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        </svg>
      </button>
    </span>
  );
}
